mutation CreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    id
    type
    title
    description
    status
    publishAt
    eventStartAt
    eventFinishAt
    startAt
    finishAt
    finishSalesAt
    showContent
    hideInGeneralLists
    perContentPurchase
    preview {
      id
      url(format: HIGH)
    }
    siteUrl
    prices {
      id
      currency
      period
      trialPeriod
      trialValue
      countryAccessId
      periods {
        id
        dateFrom
        value
        oldValue
      }
    }
    videosCount
    streamsCount
    collectionsCount
    createdAt
    updatedAt
  }
}
